import BackupIcon from "@mui/icons-material/Backup";
import CloseIcon from "@mui/icons-material/Close";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import StopRoundedIcon from "@mui/icons-material/StopRounded";
import { LoadingButton } from "@mui/lab";
import {
  Button,
  Grid,
  IconButton,
  Modal,
  Slider,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import moment from "moment";
import { memo, useCallback, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Fileuploadrequestcall } from "../../../request/Fileuploadrequest";
import { BIGrey, BILightGrey, imageCompress } from "../../../assets/helpers";
import Loader from "../../../common/Loader";
import { SAVE_CLIENT_SITE_FILING_FILES } from "../../../constant/Apipath";
import { GetIcon, GetType } from "../component/GetFileType";
import SiteFilePreview from "../component/previewModel/SiteFilePreview";
import ClientSiteFilingProgressComponent from "./ClientSiteFilingProgressComponent";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";

let AccentColor;

export default function ClientSiteFilingAddModel(props) {
  const { isOpen, onClose, reloadData } = props;

  const inputRef = useRef();

  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  AccentColor = selectedClientData?.AccentColor;
  const { siteid = 0, folderId = 0 } = useParams();

  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;

  const [data, setData] = useState([]);
  const [preview, setpreview] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showProgress, setShowProgress] = useState(false);
  const [progressData, setProgressData] = useState([]);
  const [addLoader, setAddLoader] = useState(false);
  const [isReload, setIsReload] = useState(false);

  const LANGUAGE = ClientEnglishFallback.ClientSiteFilingAddModel(
    multiLanguageData?.ClientSiteFilingAddModel || {}
  );
  const {
    TEXT_UPLOADED_FILES,
    TEXT_AS_WELL,
    TEXT_ADD_FILES,
    BUTTON_SUBMIT,
    TEXT_NO_PREVIEW,
    TEXT_SAY_SOMETHING,
    TEXT_UPLOAD_FILES,
    BUTTON_DONE
  } = LANGUAGE;

  const handleClose = (flag) => {
    onClose();
    setData([]);
    setProgressData([]);
    setShowProgress(false);
    setIsReload(false);
    if (flag) reloadData();
  };

  const uploadFile = async (item, i) => {
    let ClientJobId = siteid;
    const formData = new FormData();
    formData.append("Id", 0);
    formData.append("ClientId", selectedClientData?.ClientId);
    formData.append("ModifiedBy", Number(USER_ID));
    formData.append("ClientJobId", ClientJobId);
    formData.append("FolderId", folderId);
    formData.append("FileName", item?.file ?? item?.Blob);
    formData.append("Description", item?.description);

    const onUploadProgress = (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      setProgressData((prev) =>
        prev?.map((progressItem, index) => {
          if (index === i) {
            return {
              ...progressItem,
              progress: percentCompleted
            };
          }
          return progressItem;
        })
      );
    };

    try {
      let res = await Fileuploadrequestcall(
        SAVE_CLIENT_SITE_FILING_FILES,
        formData,
        TOKEN,
        onUploadProgress
      );

      setProgressData((prev) =>
        prev?.map((progressItem, index) => {
          if (index === i) {
            return {
              ...progressItem,
              status: res?.status,
              error: res?.message || ""
            };
          }
          return progressItem;
        })
      );
      return res;
    } catch (error) {
      console.log("uploadFile-> Error Saving Client Site Filing Files: ", error);
      setProgressData((prev) =>
        prev?.map((progressItem, index) => {
          if (index === i) {
            return {
              ...progressItem,
              status: "Failed",
              error: error.message || "Unknown error"
            };
          }
          return progressItem;
        })
      );
      throw error;
    }
  };

  const handelSubmit = async () => {
    setIsLoading(true);

    let temp = data?.map((item, i) => ({
      fileName: item?.file?.name,
      progress: 0,
      status: "Uploading",
      error: ""
    }));
    setProgressData(temp);
    setShowProgress(true);

    try {
      await Promise.all(data?.map((item, i) => uploadFile(item, i)));
      setIsReload(true);
    } catch (error) {
      console.error("handelSubmit-> One or more uploads failed: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveFile = useCallback((index) => {
    setData((prevData) => prevData.filter((_, i) => i !== index));
  }, []);

  const handelTextChange = useCallback(
    (e, index) => {
      let inputValue = e?.target?.value.replace(/^[^A-Za-z0-9]+/, "");
      let text = inputValue;
      let temp = [...data];

      let res = temp?.map((item, i) => (index === i ? { ...item, comment: text } : { ...item }));
      setData(res);
    },
    [data]
  );

  const handelFileAdd = async (e) => {
    const files = e.target.files;
    if (!files) return;

    const Temp = [...data];

    const compressionTasks = Array.from(files)?.map(async (file) => {
      const compressedFile = await imageCompress(file); // Compress the file
      return {
        description: "",
        file: compressedFile
      };
    });

    try {
      setAddLoader(true);
      // Wait for all the compression tasks to complete
      const compressedFiles = await Promise.all(compressionTasks);
      setAddLoader(false);

      Temp.push(...compressedFiles);
      setData(Temp);
    } catch (error) {
      setAddLoader(false);

      console.error("handelFileAdd-> Error compressing files: ", error);
    }

    e.target.value = "";
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => {
          if (isLoading) return;
          handleClose(isReload);
        }}>
        <div className="site-Filing">
          {!showProgress ? (
            <>
              <div className="action-button-container">
                <div></div>
                <IconButton
                  onClick={() => {
                    handleClose(false);
                  }}
                  sx={{
                    color:
                      selectedClientData?.AccentColor !== undefined &&
                      selectedClientData?.AccentColor
                        ? selectedClientData?.AccentColor
                        : BILightGrey
                  }}>
                  <CloseIcon />
                </IconButton>
              </div>
              <Stack
                sx={{ padding: {
                  xs: 0,
                  sm: 0,
                  md: 0.5,
                  lg: 0.5,
                  xl: 1
                 }}}>
                {!addLoader ? (
                  <>
                    <Grid sx={{ mb: 1 }} container spacing={1} size={12}>
                      <Grid size={12}>
                        <Stack sx={{ display: "flex", justifyContent: "space-between" }} direction={"row"} alignSelf={"center"}>
                          <Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                            {TEXT_UPLOAD_FILES}
                          </Typography>
                          {data?.length > 0 && (
                            <Typography
                              sx={{
                                cursor: "pointer",
                                color: AccentColor
                              }}
                              onClick={() => {
                                inputRef.current.click();
                              }}>
                              {TEXT_ADD_FILES}
                            </Typography>
                          )}
                        </Stack>
                      </Grid>
                    </Grid>
                    {data?.length == 0 && (
                      <Stack sx={{ display: "flex", justifyContent: "center" }} alignSelf={"center"} height={"200px"} width={"100%"}>
                        <Button
                          onClick={() => inputRef.current.click()}
                          fullWidth
                          sx={{
                            textTransform: "none",
                            borderRadius: "10px",
                            color: AccentColor,
                            display: "flex",
                            fontSize: "18px",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "200px",
                            border: `1px dashed ${AccentColor}`
                          }}>
                          <BackupIcon
                            sx={{
                              color: AccentColor,
                              height: "50px",
                              width: "50px"
                            }}
                          />
                          {TEXT_ADD_FILES}
                        </Button>
                      </Stack>
                    )}
                    {data?.length > 0 && (
                      <Grid
                        maxHeight={"450px"}
                        overflow={"scroll"}
                        container
                        spacing={1}
                        size={12}>
                        {data?.map((item, index) => {
                          return (
                            <CheckFileTypeMemo
                              index={index}
                              key={index}
                              data={item}
                              setpreview={setpreview}
                              setFileUrl={setFileUrl}
                              handelFileRemove={handleRemoveFile}
                              handelTextChange={handelTextChange}
                              textNoPreview={TEXT_NO_PREVIEW}
                              textSaySomething={TEXT_SAY_SOMETHING}
                              selectedClientData={selectedClientData}
                            />
                          );
                        })}
                      </Grid>
                    )}
                  </>
                ) : (
                  <Stack sx={{ display: "flex",  justifyContent: "center", alignItems: "center" }}  width={"100%"} height={"300px"}>
                    <Loader />
                  </Stack>
                )}
                <Stack sx={{ mt: 1 }} spacing={1}>
                  <Typography
                    sx={{
                      color: BIGrey
                    }}>
                    {TEXT_UPLOADED_FILES}
                  </Typography>
                  <Typography
                    sx={{
                      color: BIGrey
                    }}>
                    {TEXT_AS_WELL}
                  </Typography>
                  <LoadingButton
                    onClick={() => handelSubmit()}
                    fullWidth
                    loading={isLoading}
                    loadingPosition="start"
                    startIcon={<></>}
                    disabled={data?.length == 0}
                    sx={{
                      textTransform: "none",
                      bgcolor: data?.length == 0 ? "lightgrey" : AccentColor,
                      borderRadius: "10px",
                      color: "white"
                    }}>
                    {BUTTON_SUBMIT}
                  </LoadingButton>
                </Stack>
              </Stack>
            </>
          ) : (
            <>
              <ClientSiteFilingProgressComponent data={progressData} />
              <LoadingButton
                onClick={() => handleClose(true)}
                fullWidth
                loading={isLoading}
                loadingPosition="start"
                startIcon={<></>}
                sx={{
                  mt: 1,
                  textTransform: "none",
                  bgcolor: data?.length === 0 ? "lightgrey" : AccentColor,
                  borderRadius: "10px",
                  color: "white"
                }}>
                {BUTTON_DONE}
              </LoadingButton>
            </>
          )}
        </div>
      </Modal>
      <SiteFilePreview
        open={preview}
        file={fileUrl}
        showDetails={false}
        handleClose={() => setpreview(false)}
      />
      <input ref={inputRef} multiple onChange={(e) => handelFileAdd(e)} type="file" hidden />
    </>
  );
}

const Component = (props) => {
  const {
    data,
    setFileUrl,
    index,
    handelFileRemove,
    setpreview,
    handelTextChange,
    textNoPreview,
    textSaySomething,
    selectedClientData
  } = props;

  const file = data?.file;

  const fileURL = useMemo(() => {
    return file ? URL.createObjectURL(file) : "";
  }, [file]);

  const CheckFileType = useCallback(
    (name) => {
      switch (GetType(name)) {
        case "pdf":
          return (
            <div
              style={{
                position: "relative"
              }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 99
                }}
                size="small"
                onClick={() => {
                  setpreview(true);
                  setFileUrl({
                    fileUrl: fileURL,
                    name: file?.name
                  });
                }}>
                <PlayArrowRoundedIcon
                  sx={{
                    color: AccentColor
                  }}
                />
              </IconButton>
              <iframe
                style={{
                  width: "100%",
                  height: "150px",
                  marginBottom: "10px"
                }}
                title=" "
                src={fileURL}
              />
            </div>
          );
        case "image":
          return (
            <>
              <img
                loading="lazy"
                onClick={() => {
                  setpreview(true);
                  setFileUrl({
                    fileUrl: fileURL,
                    name: file?.name
                  });
                }}
                alt="no data"
                src={fileURL}
                style={{
                  width: "100%",
                  height: "150px",
                  marginBottom: "10px",
                  borderRadius: "5px",
                  objectFit: "cover"
                }}
              />
            </>
          );
        case "audio":
          return <AudioComponent src={fileURL} />;

        case "video":
          return (
            <div
              style={{
                position: "relative"
              }}>
              <IconButton
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: 99
                }}
                size="small"
                onClick={() => {
                  setpreview(true);
                  setFileUrl({
                    fileUrl: fileURL,
                    name: file?.name
                  });
                }}>
                <PlayArrowRoundedIcon
                  sx={{
                    color: "white"
                  }}
                />
              </IconButton>
              <video
                src={fileURL}
                style={{
                  width: "100%",
                  height: "150px",
                  marginBottom: "10px",
                  borderRadius: "5px",
                  objectFit: "cover"
                }}
              />
            </div>
          );
        default:
          return (
            <div
              style={{
                width: "100%",
                height: "150px",
                marginBottom: "10px",
                borderRadius: "5px",
                display: "flex",
                alignItems: "center",
                border: "1px solid #e4e4e4",
                justifyContent: "center"
              }}>
              <Typography
                sx={{
                  textAlign: "center",
                  color: BIGrey
                }}>
                {textNoPreview}
              </Typography>
            </div>
          );
      }
    },
    [fileURL]
  );

  return (
    <Grid
      sx={{
        border: "1px solid #e4e4e4",
        borderRadius: "10px",
        padding: "0px 10px 10px 10px"
      }}
      rowGap={1}
      size={{
        xs: 12,
        sm: 6,
        lg: 6,
        md: 4,
        xl: 4
      }}
      key={index}>
      <Stack sx={{ display: "flex",  justifyContent: "space-between", alignItems: "center" }}  direction={"row"}>
        <Stack spacing={1} direction={"row"}>
          {GetIcon(file?.name, AccentColor)}
          <Typography
            sx={{
              wordBreak: "break-all",
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 1
            }}>
            {file?.name}
          </Typography>
        </Stack>
        <IconButton
          onClick={() => {
            handelFileRemove(index);
          }}>
          <CloseIcon
            sx={{
              color:
                selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                  ? selectedClientData?.AccentColor
                  : BILightGrey
            }}
          />
        </IconButton>
      </Stack>
      {CheckFileType(file?.name)}

      <TextField
        onChange={(e) => {
          handelTextChange(e, index);
        }}
        slotProps={{
          input: {
            rows: 4,
            multiline: true,
            inputComponent: "textarea"
          }
        }}
        value={data.comment}
        fullWidth
        placeholder={textSaySomething}
        rows={4}
        sx={{
          borderRadius: "5px",
          "& fieldset": {
            border: "none",
            padding: 0
          },
          "& .MuiInputBase-root": {
            padding: "5px"
          },
          backgroundColor: "#e4e4e4"
        }}
      />
    </Grid>
  );
};

// !! this is file listing on the basis of the file extension it return specific component
const CheckFileTypeMemo = memo(Component);

const AudioComponent = ({ src }) => {
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const audioRef = useRef();
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  const handleTimeUpdate = () => {
    setCurrentTime(audioRef.current.currentTime);
    if (audioRef.current.currentTime === audioRef.current.duration) {
      setIsAudioPlaying(false);
    }
  };
  const handleLoadedMetadata = (e) => {
    setDuration(audioRef.current.duration);
  };

  const HandelPlayPause = () => {
    try {
      if (isAudioPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsAudioPlaying((prev) => !prev);
    } catch (error) {
      console.error("HandelPlayPause-> Error In Play/Pause: ",error);
    }
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          height: "150px",
          marginBottom: "10px  "
        }}>
        <Stack width={"100%"} direction={"row"} spacing={1} sx={{ alignItems: "center" }}>
          <IconButton size="small" onClick={() => HandelPlayPause()}>
            {isAudioPlaying ? <StopRoundedIcon /> : <PlayArrowRoundedIcon />}
          </IconButton>
          <Slider
            style={{
              color: AccentColor
            }}
            size="small"
            step={0.01}
            type="range"
            max={duration}
            value={currentTime}
            // onChange={handleSeek}
          />
          <Typography>{moment.utc(duration * 1000).format("m:ss")}</Typography>
        </Stack>
        <audio
          hidden
          onTimeUpdate={handleTimeUpdate}
          onLoadedMetadata={handleLoadedMetadata}
          ref={audioRef}
          src={src}
        />
      </div>
    </>
  );
};
